import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createLayerComponent } from '@react-leaflet/core';
import LeafletCanvasLayer from './LeafletCanvasLayer';
import paneHelpers from '../../helpers/pane';
function createLeafletElement(props, context) {
  var paneKey = paneHelpers.getKey(props.mapKey, props.uniqueLayerKey);
  var instance = new LeafletCanvasLayer({
    paneName: paneKey,
    paneZindex: props.zIndex
  });

  // ensure the canvas and the corresponding pane have been created in the DOM, before features are added
  setTimeout(function () {
    instance.setProps(props);
  }, 10);
  return {
    instance: instance,
    context: _objectSpread(_objectSpread({}, context), {}, {
      overlayContainer: instance
    })
  };
}
function updateLeafletElement(instance, props, prevProps) {
  if (prevProps.zIndex !== props.zIndex) {
    var paneKey = paneHelpers.getKey(props.mapKey, props.uniqueLayerKey);
    instance.setPaneZindex(paneKey, props.zIndex);
  }

  // TODO
  if (prevProps.selected !== props.selected || prevProps.features !== props.features || prevProps.style !== props.style || prevProps.omittedFeatureKeys !== props.omittedFeatureKeys) {
    // ensure that the layer was already created (see comment above)
    setTimeout(function () {
      instance.setProps(props);
    }, 10);
  }
}
var CanvasVectorLayer = createLayerComponent(createLeafletElement, updateLeafletElement);
export default CanvasVectorLayer;